import React from "react";
import { LoadingOutlined } from "@ant-design/icons";
import { Spin } from "antd";
import styled, { keyframes, css } from "styled-components";

const Wrap = styled.div`
  justify-content: center;
  align-items: center;
  display: flex;
  width: 100%;
  height: 100%;
`;

const Main = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  color: ${(props) => props.color || "#4432F5"};
`;
const blink = keyframes`
  0% { opacity: 0.1; }
  30% { opacity: 1; }
  100% { opacity: 0.1; }
`;
const Arrow = styled.div`
  width: 0;
  height: 0;
  animation: ${blink} 1s infinite;

  ${(props) =>
    props.size &&
    css`
      margin: 0 -${props.size / 2}px;
      border-left: ${props.size}px solid transparent;
      border-right: ${props.size}px solid transparent;
      border-bottom: ${props.size * 1.8}px solid ${props.color};
      filter: drop-shadow(0 0 ${props.size * 1}px ${props.color});
    `}

  ${(props) =>
    props.down &&
    css`
      transform: rotate(180deg);
    `}
`;

const Arrows = {};
function addArrows(name = "Arrow", length) {
  Array.from({ length }).forEach((_, index) => {
    Arrows[`${name}${index + 1}`] = styled(Arrow)`
      animation-delay: ${-(1 / length) * (index + 1)}s;
    `;
  });
}
addArrows("Outer", 18);
addArrows("Inner", 6);

const smallLoader = <LoadingOutlined style={{ fontSize: 15 }} spin />;

export default function Loader(props) {
  let content = (
    <Main color={props.color}>
      <LoadingOutlined style={{ fontSize: 40 }} spin />
    </Main>
  );

  if (props.small) {
    content = <Spin indicator={smallLoader} />;
  }

  return <Wrap>{content}</Wrap>;
}

Loader.defaultProps = {
  color: "#4432F5",
  size: 10,
};

Spin.setDefaultIndicator(smallLoader);
